import { MuiThemeProvider } from '@material-ui/core/styles'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from '@praxis/component-auth'
import { EnvProvider } from '@praxis/component-runtime-env'

import muiTheme from './config/themeConfig'
import { Provider } from 'react-redux'
import AppLayout from './components/containers/AppLayout'
import configureStore from './store/configureStore'

const store = configureStore()

const App = () => {
  return (
    <EnvProvider
      configPath={
        process.env.NODE_ENV === 'development'
          ? '/config.json'
          : '/app-environment'
      }
    >
      {({ env }) => {
        const { oauth } = env

        return (
          <AuthProvider {...oauth}>
            <MuiThemeProvider theme={muiTheme}>
              <Provider store={store}>
                <BrowserRouter>
                  {/* <Switch> */}
                  {/* Display SignInSuccess without Layout */}
                  {/* <Route exact={true} path="/auth/login" component={SignInSuccess} /> */}
                  {/* <Route path="/" component={Layout} /> */}
                  {/* </Switch> */}
                  <AppLayout />
                </BrowserRouter>
              </Provider>
            </MuiThemeProvider>
          </AuthProvider>
        )
      }}
    </EnvProvider>
  )
}

export default App
